import { render, staticRenderFns } from "./AgriculturalSubsidyDataTab.vue?vue&type=template&id=51049190&scoped=true"
import script from "./AgriculturalSubsidyDataTab.vue?vue&type=script&lang=js"
export * from "./AgriculturalSubsidyDataTab.vue?vue&type=script&lang=js"
import style0 from "./AgriculturalSubsidyDataTab.vue?vue&type=style&index=0&id=51049190&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51049190",
  null
  
)

export default component.exports